import React from 'react';
import styled from 'styled-components';
import { tokens } from '../../public/tokens';
import { iconBadge, listResetStyle } from './primitives';
import { bodyText, labelText } from './text';

const { colors, globals } = tokens;

export const ChecklistWrapper = styled.ul(({ $padding }) => ({
    ...listResetStyle,
    padding: $padding || '12px',
    flex: 5,
    minWidth: 0,
}));

export const ChecklistItem = styled.li({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: globals['spacing-sm'],
    position: 'relative',
    paddingBottom: globals['spacing-md'],

    '&:last-child': {
        paddingBottom: 0,
    },

    '&:not(:last-child)::before': {
        content: '""',
        position: 'absolute',
        left: '9px',
        top: '22px',
        bottom: 0,
        width: '1.5px',
        background: colors.ui.border,
    },
});

export const ChecklistIcon = styled.span(({ $done, $error }) => ({
    ...iconBadge,
    width: '20px',
    height: '20px',
    flexShrink: 0,
    marginTop: '2px',
    position: 'relative',
    zIndex: 1,
    background: colors.surfaces['container-background'],
    color: $error ? colors.states.alert.default : $done ? colors.states.success.default : colors.neutral.grey['400'],
}));

export const ChecklistLabel = styled.div({
    ...labelText,
});

export const ChecklistDescription = styled.div({
    ...bodyText,
});

/**
 * Generic requirements/status checklist - callers own icon selection, since which
 * icon means done/pending/error is per-feature presentation logic.
 * Give an item an `id` when its `label` can change between renders, so the row is
 * updated rather than remounted.
 */
function Checklist({ items, padding }) {
    return (
        <ChecklistWrapper $padding={padding}>
            {items.map((item) => (
                <ChecklistItem key={item.id || item.label}>
                    <ChecklistIcon $done={item.done} $error={!!item.error}>
                        <i className={item.icon}></i>
                    </ChecklistIcon>
                    <div>
                        <ChecklistLabel>{item.label}</ChecklistLabel>
                        <ChecklistDescription>{item.description}</ChecklistDescription>
                    </div>
                </ChecklistItem>
            ))}
        </ChecklistWrapper>
    );
}

export default Checklist;
